import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { AccountData } from "../../../models/AccountData";

import "./styles.scss";

type FindUserResultsProps = {
  accountData: AccountData;
};

const FindUserResults: React.FC<FindUserResultsProps> = ({ accountData }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`findUserAccountPage.results.${key}`);

  return (
    <div className="find-account__main__result">
      <p>
        <strong>{accountData.email}</strong>
      </p>
      <h4>{t("type")}</h4>
      <p>{t(accountData.type)}</p>
      {accountData.organization && (
        <>
          <h4>{t("organization")}</h4>
          <p>{accountData.organization.name}</p>
          <Link
            to={`/admin/organizations/${accountData.organization.id}/accounts`}
            className="btn btn-blue"
          >
            {t("manage_organization_members")}
          </Link>
        </>
      )}
      <h4>{t("registered_locations")}</h4>
      {accountData.locations_accounts.length > 0 ? (
        <ol>
          {accountData.locations_accounts.map(({ locations }) => (
            <li key={locations.id}>
              <Link to={`/location/${locations.id}/`}>{locations.name}</Link>
            </li>
          ))}
        </ol>
      ) : (
        <p>{t("no_registered_locations")}</p>
      )}
    </div>
  );
};

export default FindUserResults;
